export default "__VITE_ASSET__DHRgTe$W__"